import { render, staticRenderFns } from "./HMessage.vue?vue&type=template&id=78e6a946&scoped=true&"
import script from "./HMessage.vue?vue&type=script&lang=js&"
export * from "./HMessage.vue?vue&type=script&lang=js&"
import style0 from "./HMessage.vue?vue&type=style&index=0&id=78e6a946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6a946",
  null
  
)

export default component.exports